



import WalletSection from '../sections/wallet/default';




import "./style.css";

const WalletPage = ()=>{
return (
<div id="walletPage" className="page">
  
  

  
  <WalletSection />
  
  
  
</div>
)
}

export default WalletPage;